<template>




    <div class="modal is-active"     >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
              <h1>Detail for disable</h1>
            </header>
            <section class="modal-card-body">
                <!--                  content-->

                <b-field label="User Disable">
                    <b-tag type="is-info" v-if="dataToChild.useredit !== '' ">   {{ dataToChild.useredit }}</b-tag>
                    <b-tag type="is-info" v-else>  N/A </b-tag>
                </b-field>


                <b-field label="Date Disable">
                    <b-tag type="is-info" v-if="dataToChild.dateedit !== '' ">   {{ customFormatDateF(dataToChild.dateedit) }}</b-tag>
                    <b-tag type="is-info" v-else>   N/A </b-tag>
                </b-field>


                <b-field label="Time Disable">
                    <b-tag type="is-info" v-if="dataToChild.timeedit !== '' ">   {{ customFormatTimeF(dataToChild.timeedit) }}</b-tag>
                    <b-tag type="is-info" v-else>   N/A  </b-tag>
                </b-field>


                <b-field label="Reason">
                    <b-tag type="is-warning" size="is-large" v-if="dataToChild.disable_reason !== '' ">{{ dataToChild.disable_reason }} </b-tag>
                    <b-tag type="is-warning" size="is-large" v-else > N/A </b-tag>
                </b-field>




            </section>
            <footer class="modal-card-foot">
                <b-button type="is-danger"
                          icon-left="close"
                          @click="closeBtn"  >
                    Close
                </b-button>
            </footer>
        </div>
    </div>

</template>

<script>
    import { customFormatDate , customFormatTime}  from '@/utils.js'
    export default {
        name: "HistoryDisable",
        methods:{
            closeBtn(){
                this.$emit('close')
            },
            customFormatDateF(dat){
                return customFormatDate(dat)
            },
            customFormatTimeF(dat){
                return customFormatTime(dat)
            }
        },
        props:{
            dataToChild : null ,
        },


    }
</script>

<style scoped>

</style>